import { useTranslation } from 'react-i18next';
import { ReactComponent as ItemDoneIcon } from 'assets/icons/itemDone.svg';
import Button from 'components/Button/Button';
import Toggle from 'components/Toggle/Toggle';
import { STATUS_SECTIONS } from 'constants/materialAssessment';

import type ITopicIdentificationAssistant from './interfaces/ITopicIdentificationAssistant';

import styles from './scss/TopicIdentificationAssistant.module.scss';

function TopicIdentificationAssistant({
  onChangeStatus, topic, onConfigure, isViewOnly = false,
}: ITopicIdentificationAssistant) {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.toggleWrapper}>
        <Toggle
          value={topic.id}
          checked={!!topic.active}
          name={topic.name}
          onChange={() => {
            onChangeStatus(topic.id);
          }}
          disabled={isViewOnly}
        />
        <div className={styles.topicDetails}>
          <span className={styles.topicName}>{topic.name}</span>
          <span className={styles.topicDesc}>{topic.desc}</span>
        </div>
      </div>
      <div className={styles.wrapperBtn}>
        {topic.configure === STATUS_SECTIONS.COMPLETED ? <ItemDoneIcon className={styles.icon} /> : null}
        <Button
          title={t('common.configure')}
          onClick={() => onConfigure(topic.id)}
          className={styles.button}
          disabled={!topic.active}
        />
      </div>
    </div>
  );
}

export default TopicIdentificationAssistant;
